import { NavLink } from "react-router-dom";
import { useState } from "react";

import logo from "../assets/ecotrans-logo.png";
import { useTranslation } from "react-i18next";
import Language from "./assets/Language";

const Header = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const navLinkClass = ({ isActive }) =>
    `pb-2 border-b-2 transition-all duration-300 ${
      isActive
        ? "border-green text-green"
        : "border-transparent hover:border-green"
    }`;

  return (
    <header className="w-full relative z-50 bg-dark">
      <div className="container mx-auto px-6 md:px-20 py-4 flex items-center justify-between md:justify-start gap-8">
        <NavLink to="/">
          <img className="h-12 w-28 object-contain" src={logo} alt="ecotrans" />
        </NavLink>

        <div className="hidden md:flex items-center gap-10 w-full justify-between">
          <ul className="flex items-center gap-8 font-bold text-light">
            <li>
              <NavLink className={navLinkClass} to="/">
                {t("home")}
              </NavLink>
            </li>

            <li>
              <NavLink className={navLinkClass} to="/about">
                {t("about")}
              </NavLink>
            </li>

            <li>
              <NavLink className={navLinkClass} to="/services">
                {t("services")}
              </NavLink>
            </li>

            <li>
              <NavLink className={navLinkClass} to="/contact">
                {t("contact")}
              </NavLink>
            </li>
          </ul>

          <Language />
        </div>

        <div className="flex md:hidden items-center gap-4">
          <Language />

          <button
            onClick={() => setIsOpen(!isOpen)}
            className="flex flex-col justify-between w-7 h-5"
          >
            <span
              className={`h-[3px] w-full bg-light rounded transition-all duration-300 ${
                isOpen ? "rotate-45 translate-y-[8px]" : ""
              }`}
            ></span>

            <span
              className={`h-[3px] w-full bg-light rounded transition-all duration-300 ${
                isOpen ? "opacity-0" : ""
              }`}
            ></span>

            <span
              className={`h-[3px] w-full bg-light rounded transition-all duration-300 ${
                isOpen ? "-rotate-45 -translate-y-[8px]" : ""
              }`}
            ></span>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden absolute top-full left-0 w-full bg-dark shadow-xl transition-all duration-300 overflow-hidden ${
          isOpen ? "max-h-96 py-6 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <ul className="flex flex-col items-center gap-6 font-bold text-light">
          <li>
            <NavLink
              className={navLinkClass}
              to="/"
              onClick={() => setIsOpen(false)}
            >
              {t("home")}
            </NavLink>
          </li>

          <li>
            <NavLink
              className={navLinkClass}
              to="/about"
              onClick={() => setIsOpen(false)}
            >
              {t("about")}
            </NavLink>
          </li>

          <li>
            <NavLink
              className={navLinkClass}
              to="/services"
              onClick={() => setIsOpen(false)}
            >
              {t("services")}
            </NavLink>
          </li>

          <li>
            <NavLink
              className={navLinkClass}
              to="/contact"
              onClick={() => setIsOpen(false)}
            >
              {t("contact")}
            </NavLink>
          </li>
        </ul>
      </div>
    </header>
  );
};

export default Header;
